import * as firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCf_htznPTWraQQJCAfCwBn1x9T1BndoRo",
  authDomain: "warung-si-mbok.firebaseapp.com",
  databaseURL: "https://warung-si-mbok.firebaseio.com",
  projectId: "warung-si-mbok",
  storageBucket: "warung-si-mbok.appspot.com",
  messagingSenderId: "217083199190",
  appId: "1:217083199190:web:d2490538de28487b8b1377",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
